import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components/native";
import { Pressable } from "react-native";
import VDBIcon from "@components/icons/VDBIcon";
import { IconsVariant } from "@components/icons/VDBIcon";
import { useTheme } from "styled-components/native";
import { Menu, MenuItem, MenuItemLabel } from "@gluestack-ui/themed";
import { Platform } from "react-native";
import useThreeDotMenuState from "../../../hooks/useThreeDotMenuState";
import { IconState } from "../IconUtils";
import { VDBIcons } from "@utils/VDBIcons";
import { OptionsComponentForSearchResultType } from "./types";
import { DeviceEventEmitter } from "react-native";
import { useSelector } from "react-redux";
import {
  filterMenuOptions,
  filterRequestOptions,
} from "../SearchResultGridItem/utils";
import { useUserInfo } from "@redux/slices/userInfoSlice";

const OptionsComponentForSearchResult = ({
  mItem,
  menuOptions,
  menuOptionSelected,
  favoriteClickedFunction,
  productType,
}: OptionsComponentForSearchResultType) => {
  const theme = useTheme();
  const userInfo = useUserInfo();
  const [isFavorite, setIsFavorite] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const showFavoritesAnimation = useSelector(
    (state: any) =>
      state.globalData?.app_settings?.showFavoritesAnimation ?? false
  );

  useEffect(() => {
    if (mItem?.is_favorite !== undefined) {
      setIsFavorite(mItem?.is_favorite);
    }
  }, [mItem?.is_favorite]);

  const filteredMenuOptions = useMemo(() => {
    let filtered = filterMenuOptions(menuOptions, userInfo);
    if (mItem?.custom_design_configuration) {
      filtered = filterRequestOptions(filtered);
    }
    return filtered;
  }, [menuOptions, userInfo, mItem?.custom_design_configuration]);

  const {
    setThreeDotMenuOpen,
    setThreeDotIconState,
    handlePressIn,
    handlePressOut,
    getThreeDotIconBackgroundColor,
  } = useThreeDotMenuState(false);

  return (
    <OptionsContainer>
      {!userInfo?.isIFrame() && (
        <Pressable
          onPress={() => {
            if (!isFavorite && showFavoritesAnimation) {
              DeviceEventEmitter.emit("animateFavoritesTab");
            }
            favoriteClickedFunction(isFavorite, mItem);
          }}
        >
          {" "}
          <VDBIcon
            color={theme[isFavorite ? "error-01" : "core-06"]}
            size={24}
            variant={IconsVariant.VDBCustom}
            name={isFavorite ? VDBIcons.FAV : VDBIcons.FAV_EMPTY}
          />
        </Pressable>
      )}

      {!isMenuOpen ? (
        <Pressable
          onPressIn={handlePressIn}
          onPressOut={handlePressOut}
          onPress={() => {
            setIsMenuOpen(true);
            setThreeDotMenuOpen(true);
            setThreeDotIconState(IconState.Selected);
          }}
        >
          <VDBIcon
            color={getThreeDotIconBackgroundColor(theme)}
            size={24}
            variant={IconsVariant.VDBCustom}
            name={VDBIcons.DOTS_MENU_FILLED}
          />
        </Pressable>
      ) : (
        <Menu
          mt={Platform.OS === "ios" ? 0 : -15}
          py={0}
          useRNModal={false}
          marginRight={10}
          placement="top"
          shouldFlip={true}
          isOpen={true}
          onClose={() => {
            setIsMenuOpen(false);
            setThreeDotMenuOpen(false);
            setThreeDotIconState(IconState.Unselected);
          }}
          trigger={({ ...triggerProps }) => (
            <Pressable
              onPressIn={handlePressIn}
              onPressOut={handlePressOut}
              onPress={() => {
                setIsMenuOpen(false);
                setThreeDotMenuOpen(false);
                setThreeDotIconState(IconState.Unselected);
              }}
              {...triggerProps}
            >
              <VDBIcon
                color={getThreeDotIconBackgroundColor(theme)}
                size={24}
                variant={IconsVariant.VDBCustom}
                name={VDBIcons.DOTS_MENU_FILLED}
              />
            </Pressable>
          )}
        >
          {filteredMenuOptions?.map((option, index) => (
            <MenuItem
              key={option.name}
              textValue={option.label}
              style={{ padding: 0 }}
              onPress={() => {
                setIsMenuOpen(false);
                setThreeDotMenuOpen(false);
                setThreeDotIconState(IconState.Unselected);
                menuOptionSelected(option.name, mItem, productType);
              }}
            >
              <MenuItemContainer>
                <MenuItemStyle>
                  <MenuItemLabel
                    fontSize={12}
                    fontWeight={"600"}
                    size="xs"
                    color={theme["core-06"]}
                  >
                    {option.label}
                  </MenuItemLabel>
                </MenuItemStyle>
                {index < filteredMenuOptions.length - 1 && (
                  <LineView theme={theme} />
                )}
              </MenuItemContainer>
            </MenuItem>
          ))}
        </Menu>
      )}
    </OptionsContainer>
  );
};

const OptionsContainer = styled.View`
  height: auto;
  width: 24px;
  flex_direction: column;
  justify-content: space-between;
  margin-right: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
`;

const LineView = styled.View<any>`
  height: 1px;
  background-color: ${({ theme }) => theme["core-03"]};
  width: auto;
`;

const MenuItemStyle = styled.View`
  border-color: #000000;
  width: 200px;
  padding: 10px;
`;

const MenuItemContainer = styled.View``;

export default OptionsComponentForSearchResult;
